export default __webpack_public_path__ + "static/media/plusIcon.c2014291.svg";